export const DI = {
    UTILS: {
        IApiPathManager: 'IApiPathManager',
        IHttpAdapter: 'IHttpAdapter',
    },
    USECASES: {
        IGetProfileAvatarsUseCase: 'IGetProfileAvatarsUseCase',
        IGetUserRevisionUseCase: 'IGetUserRevisionUseCase',
        IGetDetailsConfigurationsUseCase: 'IGetDetailsConfigurationsUseCase',
        IGetLanguageUseCase: 'IGetLanguageUseCase',
        IGetScreenUseCase: 'IGetScreenUseCase',
        IGetSearchSuggestionsUseCase: 'GetSearchSuggestionsUseCase',
        IGetSearchPAUseCase: 'IGetSearchPAUseCase',
        IGetGatewayConfigurationUseCase: 'IGetGatewayConfigurationUseCase',
        IGetGatewayLanguageUseCase: 'IGetGatewayLanguageUseCase',
        IGetGatewayScreenUseCase: 'IGetGatewayScreenUseCase',
        IAddDeviceUseCase: 'IAddDeviceUseCase',
        IDeleteDeviceUseCase: 'IDeleteDeviceUseCase',
        IGetDevicesUseCase: 'IGetDevicesUseCase',
        IGetSubscriptionStatusUseCase: 'IGetSubscriptionStatusUseCase',
        IForgetPinUseCase: 'IForgetPinUseCase',
        IB2BForgetPinUseCase: 'IB2BForgetPinUseCase',
        IGetPromotionsUseCase: 'IGetPromotionsUseCase',
        IGetRewindsUseCase: 'IGetRewindsUseCase',
        IGetByPopcornUrlUseCase: 'IGetByPopcornUrlUseCase',
        IGetVodListAndYouWatchedUseCase: 'IGetVodListAndYouWatchedUseCase',
        IGetTAFeedUseCase: 'IGetTAFeedUseCase',
        IGetRelatedUseCase: 'IGetRelatedUseCase',
        IGetRelatedOthersUseCase: 'IGetRelatedOthersUseCase',
        IGetBecauseYouWatchedMultipleUseCase: 'IGetBecauseYouWatchedMultipleUseCase',
        INetflixForgotAccountUseCase: 'INetflixForgotAccountUseCase',
        IQitafGenerateOtpUseCase: 'IQitafGenerateOtpUseCase',
        ISubscriptionQitafGenerateOtpUseCase: 'ISubscriptionQitafGenerateOtpUseCase',
        IQitafTvodGenerateOtpUseCase: 'IQitafTvodGenerateOtpUseCase',
        IQitafVerifyOtpUseCase: 'IQitafVerifyOtpUseCase',
        ISubscriptionQitafVerifyOtpUseCase: 'ISubscriptionQitafVerifyOtpUseCase',
        IQitafTvodVerifyOtpUseCase: 'IQitafTvodVerifyOtpUseCase',
        IAllowedCountriesUseCase: 'IAllowedCountriesUseCase',
        IAvailablePackagesUseCase: 'IAvailablePackagesUseCase',
        IGetTvodUseCase: 'IGetTvodUseCase',
        IGetAllUseCase: 'IGetAllUseCase',
        IAllowedChanelsUseCase: 'IAllowedChanelsUseCase',
        IGetProfileMiniEpgChannelsUseCase: 'IGetProfileMiniEpgChannelsUseCase',
        ISubscribeUseCase: 'ISubscribeUseCase',
        ITvodPurchaseUseCase: 'ITvodPurchaseUseCase',
        IPaymentSwitchGeneratePinUseCase: 'IPaymentSwitchGeneratePinUseCase',
        IPaymentSwitchVerifyPinUseCase: 'IPaymentSwitchVerifyPinUseCase',
        IGetAllSubscriptionTiersUseCase: 'IGetAllSubscriptionTiersUseCase',
        IGetAmazonActivationLinkUseCase: 'IGetAmazonActivationLinkUseCase',
        IAmazonAccountRecoveryUseCase: 'IAmazonAccountRecoveryUseCase',
        IGetTvodPricingTemplatesUseCase: 'IGetTvodPricingTemplatesUseCase',
        ITvodOtpGenerateUseCase: 'ITvodOtpGenerateUseCase',
        ITvodOtpVerifyUseCase: 'ITvodOtpVerifyUseCase',
        ICreateParentalLockUseCase: 'ICreateParentalLockUseCase',

        ITpayRedirectSubscribeNewUseCase: 'ITpayRedirectSubscribeNewUseCase',
        ITpayRedirectSubscribeExistingUseCase: 'ITpayRedirectSubscribeExistingUseCase',
        IUnsubscribeUseCase: 'IUnsubscribeUseCase',
        IBoltUserSubscriptionTwoStepsUseCase: 'IBoltUserSubscriptionTwoStepsUseCase',
        IBoltUserSubscriptionUseCase: 'IBoltUserSubscriptionUseCase',
        IBoltUserVerificationTwoStepsUseCase: 'IBoltUserVerificationTwoStepsUseCase',
        IUserRegisterGeneratePinUseCase: 'IUserRegisterGeneratePinUseCase',
        IUserRegisterUseCase: 'IUserRegisterUseCase',
        UserRegisterVerifyPinUseCase: 'UserRegisterVerifyPinUseCase',
        ISetReminderUseCase: 'ISetReminderUseCase',
        IUnSetReminderUseCase: 'IUnSetReminderUseCase',
        IListReminderUseCase: 'IListReminderUseCase',
        IZendeskSubmitFormUseCase: 'IZendeskSubmitFormUseCase',
        IValidateGiftCardUseCase: 'IValidateGiftCardUseCase',
        ISubscribeViaGiftCardUseCase: 'ISubscribeViaGiftCardUseCase',
        IReSubscribeViaGiftCardUseCase: 'IReSubscribeViaGiftCardUseCase',
        IActiveSubscriptionRedeeemGiftCardUseCase: 'IActiveSubscriptionRedeeemGiftCardUseCase',
        IGiftCardUserResubscribeUseCase: 'IGiftCardUserResubscribeUseCase',
        IGiftCardUserResubscribeVerifyUseCase: 'IGiftCardUserResubscribeVerifyUseCase',
        IFormSignatureUseCase: 'IFormSignatureUseCase',
        IVerifyEmailUseCase: 'IVerifyEmailUseCase',
        IFormSignatureObjectUseCase: 'IFormSignatureObjectUseCase',

        IGetChannelMiniEPGUseCase: 'IGetChannelMiniEPGUseCase',
        IGetChannelsUseCase: 'IGetChannelsUseCase',
        IGetAllChannelsUseCase: 'IGetAllChannelsUseCase',
        IGetChannelInfoUseCase: 'IGetChannelInfoUseCase',
        IGetChannelScheduleUseCase: 'IGetChannelScheduleUseCase',
        IGetChannelScheduleByDataSourceUseCase: 'IGetChannelScheduleByDataSourceUseCase',
        IGetChannelsArrisSTBUseCase: 'IGetChannelsArrisSTBUseCase',

        ILocateUserUseCase: 'ILocateUserUseCase',
        IGenerateEmailVerifcationPinUseCase: 'GenerateEmailVerifcationPinUseCase',
        IVerifyEmailVerifcationPinUseCase: 'IVerifyEmailVerifcationPinUseCase',
        ILoginStep1UseCase: 'ILoginStep1UseCase',
        ILoginCredentialsUseCase: 'ILoginCredentialsUseCase',
        ILoginWithTokenUseCase: 'ILoginWithTokenUseCase',
        IGetGuestPublicConfigUseCase: 'IGetGuestPublicConfigUseCase',
        ILoginGuestUseCase: 'ILoginGuestUseCase',
        ILoginOtpStep1UseCase: 'ILoginOtpStep1UseCase',
        ILoginOtpStep2UseCase: 'ILoginOtpStep2UseCase',
        IGeneratePinUseCase: 'IGeneratePinUseCase',
        IVerifyPinUseCase: 'IVerifyPinUseCase',
        IResetPasswordStep1UseCase: 'IResetPasswordStep1UseCase',
        IResetPaswordStep2UseCase: 'IResetPaswordStep2UseCase',
        IForgotPasswordGeneratePinByEmailUseCase: 'IForgotPasswordGeneratePinByEmailUseCase',
        IForgotPasswordGeneratePinByMsisdnUseCase: 'IForgotPasswordGeneratePinByMsisdnUseCase',
        IForgotPasswordVerifyPinByEmailUseCase: 'IForgotPasswordVerifyPinByEmailUseCase',
        IForgotPasswordVerifyPinByMsisdnUseCase: 'IForgotPasswordVerifyPinByMsisdnUseCase',
        IForgotPasswordUpdatePasswordByEmailUseCase: 'IForgotPasswordUpdatePasswordByEmailUseCase',
        IForgotPasswordUpdatePasswordByMsisdnByUseCase: 'IForgotPasswordUpdatePasswordByMsisdnByUseCase',
        IQrGenerateCodeUseCase: 'IQrGenerateCodeUseCase',
        IQrAuthenticateCodeUseCase: 'IQrAuthenticateCodeUseCase',
        IQrCodeLoginUseCase: 'IQrCodeLoginUseCase',
        IQrCodePairingUseCase: 'IQrCodePairingUseCase',
        IQrCodeLinkUseCase: 'IQrCodeLinkUseCase',
        IInternalVerifyUserUseCase: 'IInternalVerifyUserUseCase',
        ISendAccountActivationUseCase: 'ISendAccountActivationUseCase',
        IPaymentSwitchGenerateUseCase: 'IPaymentSwitchGenerateUseCase',
        IPaymentSwitchVerifyUseCase: 'IPaymentSwitchVerifyUseCase',
        IResubscribeOtpSendUseCase: 'IResubscribeOtpSendUseCase',
        IResubscribeOtpVerifyUseCase: 'IResubscribeOtpVerifyUseCase',
        IResubscribeCreditCardUseCase: 'IResubscribeCreditCardUseCase',
        IGetCountryConfigsUseCase: 'IGetCountryConfigsUseCase',
        IUserUnsubscribeUseCase: 'IUserUnsubscribeUseCase',
        ILegacyMigrateUseCase: 'ILegacyMigrateUseCase',
        ILegacyMigrateGenerateUseCase: 'ILegacyMigrateGenerateUseCase',
        ILegacyMigrateVerifyUseCase: 'ILegacyMigrateVerifyUseCase',
        IGetMyLocationUseCase: 'IGetMyLocationUseCase',

        IPurchaseAddonUseCase: 'IPurchaseAddonUseCase',
        IAmazonActivateUseCase: 'IAmazonActivateUseCase',
        IBundleAndSaveUseCase: 'IBundleAndSaveUseCase',
        IBundleAndSaveRulesUseCase: 'IBundleAndSaveRulesUseCase',
        IBundleAndSaveInfoUseCase: 'IBundleAndSaveInfoUseCase',

        IGetChannelHistoryUseCase: 'IGetChannelHistoryUseCase',
        IGetSeriesHistoryUseCase: 'IGetSeriesHistoryUseCase',
        IGetProfileWatchesHistoryUseCase: 'IGetProfileWatchesHistoryUseCase',

        IAddBookmarkUseCase: 'IAddBookmarkUseCase',
        IGetBookmarkUseCase: 'IGetBookmarkUseCase',
        IGetBookmarkDetailUseCase: 'IGetBookmarkDetailUseCase',
        IDeleteBookmarkUseCase: 'IDeleteBookmarkUseCase',
        IGetWatchAgainUseCase: 'IGetWatchAgainUseCase',
        IAddProfileUseCase: 'IAddProfileUseCase',
        IDeleteProfileUseCase: 'IDeleteProfileUseCase',
        IGetProfileUseCase: 'IGetProfileUseCase',
        IUpdateProfileUseCase: 'IUpdateProfileUseCase',
        IGetProfileListUseCase: 'IGetProfileListUseCase',
        IGetProfileDetailUseCase: 'IGetProfileDetailUseCase',
        IGetProfilesUseCase: 'IGetProfilesUseCase',
        ISwitchProfileUseCase: 'ISwitchProfileUseCase',
        IAddFavoriteChannelsUseCase: 'IAddFavoriteChannelsUseCase',
        IGetFavoriteChannelsUseCase: 'IGetFavoriteChannelsUseCase',
        IDeleteFavoriteChannelsUseCase: 'IDeleteFavoriteChannelsUseCase',
        IAddWatchlistUseCase: 'IAddWatchlistUseCase',
        IGetWatchlistUseCase: 'IGetWatchlistUseCase',
        IDeleteWatchlistUseCase: 'IDeleteWatchlistUseCase',
        IAccountRetrievalGenerateOTPUseCase: 'IAccountRetrievalGenerateOTPUseCase',
        IAccountB2CRetrievalGenerateOTPUseCase: 'IAccountB2CRetrievalGenerateOTPUseCase',
        IAccountRetrievalVerifyOTPUseCase: 'IAccountRetrievalVerifyOTPUseCase',
        IAccountB2CRetrievalVerifyOTPUseCase: 'IAccountB2CRetrievalVerifyOTPUseCase',
        IGetParentalLockUseCase: 'IGetParentalLockUseCase',
        IUpdateParentalLockUseCase: 'IUpdateParentalLockUseCase',
        IResetParentalLockOTPUseCase: 'IResetParentalLockOTPUseCase',
        IValidateParentalLockUseCase: 'IValidateParentalLockUseCase',
        IValidatePasswordUseCase: 'IValidatePasswordUseCase',
        IAuthUseCase: 'IAuthUseCase',
        IGetMoviesUseCase: 'IGetMoviesUseCase',
        IGetSeriesUseCase: 'IGetSeriesUseCase',
        IGetEpisodesUseCase: 'IGetEpisodesUseCase',
        IGetFeedUseCase: 'IGetFeedUseCase',
        IGetBiographyUseCase: 'IGetBiographyUseCase',
        IGetFilmographyUseCase: 'IGetFilmographyUseCase',
        IGetProductsUseCase: 'IGetProductsUseCase',
        IUserRegisterVerifyPinUseCase: 'IUserRegisterVerifyPinUseCase',
        IValidateVOCTokenUseCase: 'IValidateVOCTokenUseCase',
        IGetPaymentUseCase: 'IGetPaymentUseCase',
        IAddLikeDislikeUseCase: 'IAddLikeDislikeUseCase',
        IGetContentRatingUseCase: 'IGetContentRatingUseCase',
        ISearchClickActionUseCase: 'ISearchClickActionUseCase',
        ILearnEventUseCase: 'ILearnEventUseCase',
        ISetPreferencesActionUseCase: 'ISetPreferencesActionUseCase',
        IAutoLoginUseCase: 'IAutoLoginUseCase',
        IDevicePairingUseCase: 'IDevicePairingUseCase',
        IForgotPasswordResendOTPUseCase: 'IForgotPasswordResendOTPUseCase',
        IForgotPasswordResetUseCase: 'IForgotPasswordResetUseCase',
        IForgotPasswordSendOTPUseCase: 'IForgotPasswordSendOTPUseCase',
        IForgotPasswordVerifyOTPUseCase: 'IForgotPasswordVerifyOTPUseCase',
        ILoginWithCredentialsUseCase: 'ILoginWithCredentialsUseCase',
        ILoginWithOTPUseCase: 'ILoginWithOTPUseCase',
        IRefreshAuthTokenUseCase: 'IRefreshAuthTokenUseCase',
        IVerifyQRCodeUseCase: 'IVerifyQRCodeUseCase',
        IVerifyUsernameUseCase: 'IVerifyUsernameUseCase',
        ILocateUsernameUseCase: 'ILocateUsernameUseCase',
        IVerifyUserUseCase: 'IVerifyUserUseCase',
        IZendeskJWTTokenUseCase: 'IZendeskJWTTokenUseCase',
        IGetProvidersUseCase: 'IGetProvidersUseCase',
        IGetFooterMenuContentUseCase: 'IGetFooterMenuContentUseCase',
        IAddConsentUseCase: 'IAddConsentUseCase',
        IGetConsentUseCase: 'IGetConsentUseCase',
        IGetMpxAllAssetsUseCase: 'IGetMpxAllAssetsUseCase',
        IGetPPVFeedUseCase: 'IGetPPVFeedUseCase',
        IGetContentDetailsUseCase: 'IGetContentDetailsUseCase',
        IGetMpxCastCrewUseCase: 'IGetMpxCastCrewUseCase',
        IGetSeasonsUseCase: 'IGetSeasonsUseCase',
        IGetHeaderMenuContentUseCase: 'IGetHeaderMenuContentUseCase',
        IGetMoodsUseCase: 'IGetMoodsUseCase',
        IGetGamesUseCase: 'IGetGamesUseCase',
        IGetChannelCategoriesUseCase: 'IGetChannelCategoriesUseCase',
        IGetChannelListByCategoryUseCase: 'IGetChannelListByCategoryUseCase',
        IGetFeelingLuckyUseCase: 'IGetFeelingLuckyUseCase',
        IGetMoodVodUseCase: 'IGetMoodVodUseCase',
        IGetCatchUpCarouselUseCase: 'IGetCatchUpCarouselUseCase',
        IGetCatchUpEpisodesUseCase: 'IGetCatchUpEpisodesUseCase',
        IGetMixedCatchUpEpisodesUseCase: 'IGetMixedCatchUpEpisodesUseCase',
        IGetCatchUpEpisodeDetailUseCase: 'IGetCatchUpEpisodeDetailUseCase',
        IGetZoneUseCase: 'IGetZoneUseCase',

        IAcquireLockUseCase: 'IAcquireLockUseCase',
        IRefreshLockUseCase: 'IRefreshLockUseCase',
        IDeleteLockUseCase: 'IDeleteLockUSeCase',
        ILogoutUseCase: 'ILogoutUseCase',
        IGetPPVEventConfigUseCase: 'IGetPPVEventConfigUseCase',
        IGetPPVCountryConfigUseCase: 'IGetPPVCountryConfigUseCase',
        IPPVPurchaseUseCase: 'IPPVPurchaseUseCase',
        IPPVPurchaseGenerateOtpUseCase: 'IPPVPurchaseGenerateOtpUseCase',
        IPPVPurchaseVerifyOtpUseCase: 'IPPVPurchaseVerifyOtpUseCase',

        IGetBadgesUseCase: 'IGetBadgesUseCase',
        IGetQuestsUseCase: 'IGetQuestsUseCase',
        ICampaignGenerateUseCase: 'ICampaignGenerateUseCase',
        ICampaignVerifyUseCase: 'ICampaignVerifyUseCase',
        ICheckUserUseCase: 'ICheckUserUseCase',
        IValidateActivationLinkUseCase: 'IValidateActivationLinkUseCase',
        IDisneyGenerateOtpUseCase: 'IDisneyGenerateOtpUseCase',
        IDisneyValidateOtpUseCase: 'IDisneyValidateOtpUseCase',
        IDisneyRequestActivationLinkUseCase: 'IDisneyRequestActivationLinkUseCase',
        IPPVPurchasePinUseCase: 'IPPVPurchasePinUseCase',
        IForgetResendPinUseCase: 'IForgetResendPinUseCase',
        IBigScreenCmsUseCase: 'IBigScreenCmsUseCase',
    },
    REPOSITORIES: {
        IUserCdnRepository: 'IUserCdnRepository',
        ICmsRepository: 'ICmsRepository',
        IThinkAnalyticsSearchRepository: 'IThinkAnalyticsSearchRepository',
        IGatewayRepository: 'IGatewayRepository',
        IDeviceRepository: 'IDeviceRepository',
        IUserRegistrationRepository: 'IUserRegistrationRepository',
        IUserIdentityRepository: 'IUserIdentityRepository',
        IPopcornRepository: 'IPopcornRepository',
        IThinkAnalyticsRepository: 'IThinkAnalyticsRepository',
        IEntitlementRepository: 'IEntitlementRepository',
        ISubscriptionRepository: 'ISubscriptionRepository',
        IReminderRepository: 'IReminderRepository',
        IZenDeskRepository: 'IZenDeskRepository',
        IDiscountRepository: 'IDiscountRepository',
        IAuthRepository: 'IAuthRepository',
        IChannelRepository: 'IChannelRepository',
        IUserRepository: 'IUserRepository',
        IGeoLocationRepository: 'IGeoLocationRepository',
        IChannelSeriesHistoryRepository: 'IChannelSeriesHistoryRepository',
        IBookmarkRepository: 'IBookmarkRepository',
        IProfileRepository: 'IProfileRepository',
        ISlpRepository: 'ISlpRepository',
        IMpxRepository: 'IMpxRepository',
        INotificationsRepository: 'INotificationsRepository',
        IPaymentConfigRepository: 'IPaymentConfigRepository',
        ILearnActionRepository: 'ILearnActionRepository',
        ICustomConfigurationRepository: 'ICustomConfigurationRepository',
        ICMSCarouselRepository: 'ICMSCarouselRepository',
        IStreamHarnessRepository: 'IStreamHarnessRepository',
        IRewardRepository: 'IRewardRepository',
        IBigScreenCmsRepository: 'IBigScreenCmsRepository',
    },
    SERVICES: {
        IUserRevisionService: 'IUserRevisionService',
        ICmsService: 'ICmsService',
        IThinkAnalyticsService: 'IThinkAnalyticsService',
        IThinkAnalyticsSearchService: 'IThinkAnalyticsSearchService',
        IGatewayService: 'IGatewayService',
        IDeviceService: 'IDeviceService',
        IUserIdentityService: 'IUserIdentityService',
        IPopcornService: 'IPopcornService',
        IEntitlementService: 'IEntitlementService',
        IReminderService: 'IReminderService',
        IZenDeskService: 'IZenDeskService',
        IDiscountService: 'IDiscountService',
        IAuthService: 'IAuthService',
        ISubscriptionService: 'ISubscriptionService',
        IUserService: 'IUserService',
        IGeoLocationService: 'IGeoLocationService',
        IChannelService: 'IChannelService',
        IChannelSeriesHistoryService: 'IChannelSeriesHistoryService',
        IBookmarkService: 'IBookmarkService',
        IProfileService: 'IProfileService',
        ISlpService: 'ISlpService',
        IMpxService: 'IMpxService',
        INotificationsService: 'INotificationsService',
        IPaymentConfigService: 'IPaymentConfigService',
        ILearnActionService: 'ILearnActionService',
        ICustomConfigurationService: 'ICustomConfigurationService',
        IUserRegistrationService: 'IUserRegistrationService',
        ICmsCarouselService: 'ICmsCarouselService',
        IStreamHarnessService: 'IStreamHarnessService',
        IRewardService: 'IRewardService',
        IBigScreenCmsPresenter: 'IBigScreenCmsPresenter',
    },
} as const;
